import React from 'react'
import SVG from 'react-inlinesvg'

export function toAbsoluteUrl(pathname) {
  return "/" + pathname
}

const SAISVG = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export default SAISVG;
